import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Iugu from 'util/iugu';
import { AMEX, DINERS, MASTERCARD, VISA } from 'constants/cardBrands';

const getBrandIconName = (number) => {
  try {
    const brand = Iugu.utils.getBrandByCreditCardNumber(number);

    switch (brand) {
      case VISA:
        return ['fab', 'cc-visa'];
      case MASTERCARD:
        return ['fab', 'cc-mastercard'];
      case AMEX:
        return ['fab', 'cc-amex'];
      case DINERS:
        return ['fab', 'cc-diners-club'];
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

const CreditCardIcon = ({ className = '', number }) => {
  const iconName = getBrandIconName(number);

  return iconName ? (
    <FontAwesomeIcon className={`icon ${className}`} icon={iconName} />
  ) : null;
};

export default CreditCardIcon;
